import React, { useState } from "react";
import cn from "classnames";
import CONFIG from "../../../config";
import SocNet from "../../../components/SocNet/SocNet";
import Complain from "../../../components/Complain/Complain";
import BaibolLogo from "../../../components/BaibolLogo/BaibolLogo";
import BaibolPhone from "../../../components/BaibolPhone/BaibolPhone";
import Menu from "../Menu/Menu";
import BlackVersionButton from "../BlackVersionButton/BlackVersionButton";
import Offices from "../Offices/Offices";
import GetMoney from "../GetMoney/GetMoney";
import PayOffTheLoan from "../PayOffTheLoan/PayOffTheLoan";

import person from '../../../assets/img/icons/person.svg';
import geolocation from '../../../assets/img/icons/geolocation.svg';

const { LINKS } = CONFIG;

const HeaderMobile: React.FC = () => {
    const [menuOpened, setMenuOpened] = useState<boolean>(false);

    const openMenuHandler = () => {
        setMenuOpened(true);
        document.body.style.overflow = 'hidden';
    }

    const closeMenuHandler = () => {
        setMenuOpened(false);
        document.body.style.overflow = '';
    }

    return (
        <div className="header__mobile">
            <div className="mobile__header__money top-block">
                <PayOffTheLoan />
                <GetMoney className="header__money__get__btn" />
            </div>
            <div className="header__mobile__work">
                <div className="mobile__logo">
                    <BaibolLogo width={87} height={19} />
                    <div className="mobile__header__money">
                        <GetMoney className="header__money__get__btn" />
                    </div>
                </div>
                <div className="header__mobile__panel">
                    <a href={LINKS.BAIBOL.OFFICES} target="_blank" rel="noopener noreferrer nofollow">
                        <img src={person} alt="Микрокредитная компания «Байбол» - Отделения Байбол" />
                    </a>
                    <a href={LINKS.TELEGRAM_BOT} target="_blank" rel="noopener noreferrer nofollow">
                        <img src={geolocation} alt="Телеграм бот @MKKBaibol_bot" />
                    </a>
                    <span
                        className="menu__mobile__btn"
                        onClick={openMenuHandler}
                    ></span>
                </div>
            </div>
            <div className={cn("mobile__menu", { 'open': menuOpened })}>
                <div className="mobile__menu__main">
                    <BaibolLogo width={87} height={19} />
                    <div className="mobile__search">
                        <form action={LINKS.BAIBOL.SEARCH} method="GET">
                            <input type="text" name="q" placeholder="Поиск по сайту" />
                            <input type="submit" value="" />
                        </form>
                    </div>
                    <div className="mobile__get__repay__money">
                        <GetMoney className="mobile__get__money__btn" />
                    </div>
                    <div className="offices__sv">
                        <BlackVersionButton />
                        <Offices parentClass="mobile__offices" />
                    </div>
                    <Menu isMobile={true} />
                </div>
                <div className="mobile__footer">
                    <BaibolPhone isMobileHeader={true} />
                    <Complain parentClass="mobile__complain" />
                    <SocNet />
                </div>
                <div
                    className="mobile__close__btn"
                    onClick={closeMenuHandler}
                ></div>
            </div>
        </div>
    );
}

export default HeaderMobile;